<!--单位树组件-->
<template>
	<div class="readDeviceTreeBody">
		<div class="cloumnsTitle">
			<div class="serialno"><span>序号</span></div>
			<div class="rightname"><span>菜单名称</span></div>
			<div class="webpage"><span>网页地址</span></div>
			<div class="enable"><span>是否启用</span></div>
			<div class="createTime"><span>创建时间</span></div>
		</div>
		<tree :getNameMethod="getNameMethod" :imgMethod="imgMethod" :menuCheckedAble='true' :nowOpenFloorIds="nowOpenFloorIds" :dataList="dataList" :getIdMethod="getIdMethod" :nowCheckId="nowCheckId" @checkItem="checkItem"></tree>
		<div class="cloumnsTitle" v-for="l in parseInt(20-(undefined == dataList.length ? 0 : dataList.length) )">
			<div class="serialno"></div>
			<div class="rightname"></div>
			<div class="webpage"></div>
			<div class="enable"></div>
			<div class="createTime"></div>
		</div>
	</div>
</template>

<script>
	import tree from '@/components/module/tree/menuTreeList.vue'
	import resourcesStore from '@/cache/resourcesStore.js'
	export default {
		components: {
			tree
		},
		props: [],
		data() {
			return {
				nowCheckId: '',
				nowCheckItem: {},
				nowOpenFloorIds: []
			}
		},
		created() {},
		mounted() {},
		destroyed() {},
		computed: {
			dataList() {
				return this.$store.menuStore.getters.getWebMenuTree
			},
		},
		watch: {
			nowCheckItem(nv, ov) {
				this.$emit("checkItem", nv)
			}
		},
		methods: {
			getNameMethod(item) {
				return item.rightname
			},
			imgMethod(item) {
				return resourcesStore.getters.getResourcesByName("tree/node_unit.png")
			},
			getIdMethod(item) {
				return item.id
			},
			checkItem(item) {
				this.nowCheckId = this.getIdMethod(item)
				this.nowCheckItem = item
			},
		}
	}
</script>

<style scoped>
	.serialno {
		border: 1px dashed #ccc;
		border-width: .01rem 0 0 .01rem;
		line-height: 38px;
		width: 15%;
	}
	
	.rightname {
		border: 1px dashed #ccc;
		border-width: .01rem 0 0 .01rem;
		line-height: 38px;
		width: 15%;
	}
	
	.icon {
		border: 1px dashed #ccc;
		border-width: .01rem 0 0 .01rem;
		line-height: 38px;
		width: 15%;
	}
	
	.webpage {
		border: 1px dashed #ccc;
		border-width: .01rem 0 0 .01rem;
		line-height: 38px;
		width: 30%;
	}
	
	.remark {
		border: 1px dashed #ccc;
		border-width: .01rem 0 0 .01rem;
		line-height: 38px;
		width: 15%;
	}
	
	.enable {
		border: 1px dashed #ccc;
		border-width: .01rem 0 0 .01rem;
		line-height: 38px;
		width: 15%;
	}
	
	.createTime {
		border: 1px dashed #ccc;
		border-width: .01rem 0 0 .01rem;
		line-height: 38px;
		width: 25%;
	}
	
	.cloumnsTitle {
		height: 38px;
		display: flex;
	}
	
	.readDeviceTreeBody {
		height: 100%;
		overflow: auto;
		background: white;
	}
</style>